import React, { useState } from "react";
import "../css/Header3.css";

const Header3 = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="header3-wrapper">

      {/* MOBILE OVERLAY */}
      <div
        className={`header3-overlay ${menuOpen ? "show" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>

      {/* MOBILE SIDE MENU */}
      <div className={`header3-mobile-menu ${menuOpen ? "open" : ""}`}>
        <div className="mobile-menu-top">
          <div className="mobile-logo">ACE</div>
          <button
            className="mobile-close"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <div className="mobile-section">
          <h4>Explore</h4>
          <a href="/trainers">Trainers</a>
          <a href="/workouts">Workouts</a>
          <a href="/services">Services</a>
          <a href="/gallery">Gallery</a>
        </div>

        <div className="mobile-section">
          <h4>Navigation</h4>
          <a href="/">Home</a>
          <a href="/about">About</a>
          <a href="/plans">Membership</a>
          <a href="/faqs">FAQs</a>
          <a href="/contact">Contact</a>
        </div>

        <div className="mobile-footer">
          © {new Date().getFullYear()} ACE FITNESS
        </div>
      </div>

      {/* TOP BLACK HEADER */}
      <header className="header3-main">

        {/* Hamburger (mobile only) */}
        <button
          className="header3-hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* LEFT SIDE: BRAND + SUBNAV */}
        <div className="header3-left">
          <div className="header3-logo">ACE</div>

          <nav className="header3-subnav">
            <a href="/trainers">Trainers</a>
            <a href="/workouts">Workouts</a>
            <a href="/services">Services</a>
            <a href="/gallery">Gallery</a>
          </nav>
        </div>

        {/* RIGHT MAIN NAV */}
        <nav className="header3-nav">
          <a href="/">Home</a>
          <a href="/about">About</a>
          <a href="/plans">Membership</a>
          <a href="/faqs">FAQs</a>
          <a href="/contact">Contact</a>
        </nav>

      </header>

      {/* WHITE QUOTE BAR */}
      <div className="header3-quote">
        Push harder — your future self is watching.
      </div>

    </div>
  );
};

export default Header3;
